import { unitMapping, type Unit } from '#src/lib/style.ts';

type Props = {
  size?: Unit;
};
export const NoCards = ({ size = 2 }: Props) => {
  return (
    <svg
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9354 16.0676L10.9072 11.7417L12.0041 10.7204L15.9594 14.9679L19.9146 10.7204L21.0115 11.7417L16.9833 16.0676L20.9482 20.3255L19.8513 21.3469L15.9594 17.1673L12.0674 21.3469L10.9705 20.3255L14.9354 16.0676Z"
        fill="currentColor"
      />
      <path
        d="M22.3994 4.80103C23.2831 4.80103 24 5.51698 24 6.40063V27.2004C23.9997 28.0839 23.2829 28.801 22.3994 28.801H9.7998C8.91635 28.801 8.20046 28.0838 8.2002 27.2004V6.40063C8.2002 5.51701 8.91619 4.80107 9.7998 4.80103H22.3994ZM6.40039 9.59985H4.7998V24.2004H6.40039V27.4006H3.2002C2.3167 27.4006 1.60085 26.6835 1.60059 25.8V8.00024C1.60059 7.11659 2.31654 6.40063 3.2002 6.40063H6.40039V9.59985ZM28.7998 6.40063C29.6835 6.40063 30.3994 7.11659 30.3994 8.00024V25.8C30.3992 26.6835 29.6833 27.4006 28.7998 27.4006H25.5996V24.2004H27.2002V9.59985H25.5996V6.40063H28.7998ZM11.3994 9.10376L10.4688 9.07153L9.37207 10.093L9.25879 13.2776L11.3994 15.5764V16.5579L9.32227 18.7903L9.43555 21.9749L10.5322 22.9963L11.3994 22.9651V25.6008H20.7998V22.9749L21.3867 22.9963L22.4834 21.9749L22.5977 18.7903L20.7998 16.8586V15.2756L22.6602 13.2776L22.5469 10.093L21.4502 9.07153L20.7998 9.09399V8.00024H11.3994V9.10376ZM11.3994 20.7239L10.9707 20.3254L11.3994 19.8645V20.7239ZM20.9482 20.3254L20.7998 20.4631V20.1653L20.9482 20.3254ZM11.3994 12.2698L10.9072 11.7415L11.3994 11.2825V12.2698ZM21.0117 11.7415L20.7998 11.969V11.5432L21.0117 11.7415Z"
        fill="currentColor"
      />
    </svg>
  );
};
